import { UserManagerSettings } from 'oidc-client-ts'

export const oidcSettings: UserManagerSettings = {
  authority: `${import.meta.env.VITE_IDENTITY_URL}`,
  client_id: 'metabolic-web-portal-spa',
  redirect_uri: `${window.location.origin}/callback`,
  response_type: 'code',
  scope: 'offline_access',
  post_logout_redirect_uri: `${window.location.origin}`,
}
